class CapsuleItem extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.toggleAccordion()
    }


    toggleAccordion() {
        const accordion = this.querySelector('.accordion_header');
        const accordionItem = this.querySelector('.accordion-item');
        if (accordion) {
            accordion.addEventListener('click',() => {
                accordionItem.classList.toggle('active');
            })
        }
    }
}

customElements.define('capsule-item', CapsuleItem);

class ProductSelectorCapsule extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector('form');
        this.variantInput = this.form.querySelector('input[name="id"]');
        this.optionElements = this.form.querySelectorAll('.product-option-label input[type="radio"]');
        this.addToCartButton = this.form.querySelector('.btn-add-to-cart');
        this.selectMessage = this.form.querySelector('.select_size-message');

        this.optionElements.forEach(option => {
            option.addEventListener('change', this.onVariantChange.bind(this));
        });

        this.form.addEventListener('submit', this.onAddToCart.bind(this));

        this.closeCartDrawer();

        try {
            this.variantData = JSON.parse(this.dataset.variants);
        } catch (error) {
            console.error('Failed to parse variant data:', error);
            this.variantData = [];
        }
    }

    onVariantChange() {
        const selectedOptions = Array.from(this.optionElements)
            .filter(input => input.checked)
            .map(input => input.value);

        this.currentVariant = this.variantData.find(variant => {
            return variant.options.every((option, index) => option === selectedOptions[index]);
        });

        if (this.currentVariant) {
            this.variantInput.value = this.currentVariant.id;
            console.log(`Variant selected: ${this.currentVariant.id}`);
            document.querySelector('.select_size-message.capsule').classList.remove('active');

            this.selectMessage.classList.remove('active');

            this.disableAddToCartButton(false);
        } else {
            this.variantInput.value = '';
            console.error('No matching variant found for the selected options');
            this.disableAddToCartButton(true);
        }
    }

    async onAddToCart(event) {
        event.preventDefault();

        if (!this.currentVariant) {
            console.error('Please select a variant before adding to cart.');
            this.selectMessage.classList.add('active');
            return;
        }

        this.disableAddToCartButton(true);

        const formData = {
            items: [
                {
                    id: this.currentVariant.id,
                    quantity: 1
                }
            ],
            sections: "cart-drawer"
        }

        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            if (response.ok) {
                const data = await response.json();
                console.log('Product added to cart:', data);

                await this.updateCartDrawer(data.sections['cart-drawer']);

                this.disableAddToCartButton(false);
            } else {
                console.error('Failed to add product to cart.');
                this.disableAddToCartButton(false);
            }
        } catch (error) {
            console.error('Error adding product to cart:', error);
            this.disableAddToCartButton(false);
        }
    }

    async updateCartDrawer(cartDrawerContent) {
        const cartRequest = await fetch('/cart.js',{
            headers: {
                'Content-Type': 'application/json'
            }
        });
        try {
            if (cartDrawerContent) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(cartDrawerContent, 'text/html');
                const newCartDrawerContent = doc.querySelector('.cart-drawer__contents');
                const cartDrawerElement = document.querySelector('.cart-drawer__contents');


                if (cartRequest.ok) {
                    const cartData = await cartRequest.json();

                    // Update the cart item count across the site
                    document.querySelectorAll('[data-js-cart-item-count]').forEach((itemCount) => {
                        itemCount.innerText = cartData.item_count;
                        itemCount.classList.toggle('is-active', cartData.item_count > 0);
                    });

                    console.log('cartdata',cartData)
                }


                if (newCartDrawerContent && cartDrawerElement) {
                    cartDrawerElement.innerHTML = newCartDrawerContent.innerHTML;

                    console.log('new',newCartDrawerContent)
                    console.log('old',cartDrawerElement)


                    this.openCartDrawer();
                } else {
                    console.error('Cart drawer section or cart-drawer element not found.');
                }
            }
        } catch (error) {
            console.error('Error updating cart drawer:', error);
        }
    }

    closeCartDrawer() {
        const cartDrawer = document.querySelector('#cart-drawer');

        document.body.addEventListener('click', (event) => {
            if (event.target.matches('[data-js-cart-drawer="cartDrawerClose"]')) {
                if (cartDrawer) {
                    console.log('clicked');
                    cartDrawer.classList.remove('active');
                } else {
                    console.error('Cart drawer not found');
                }
            }
        });
    }


    openCartDrawer() {
        const cartDrawer = document.querySelector('#cart-drawer');
        setTimeout(() => {
            cartDrawer.classList.add('animate','active');
        }, 50);
    }


    disableAddToCartButton(disabled) {
        if (disabled) {
            this.addToCartButton.setAttribute('disabled', 'disabled');
            this.addToCartButton.classList.add('is-loading');
        } else {
            this.addToCartButton.removeAttribute('disabled');
            this.addToCartButton.classList.remove('is-loading');
        }
    }
}

customElements.define('product-selector-capsule', ProductSelectorCapsule);

document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('.size-chart-button').forEach(button => {
        button.addEventListener('click', function () {
            const productId = button.getAttribute('data-product-id');
            const elSizeChartOverlay = document.getElementById(`size-chart-overlay-${productId}`);
            const elSizeChart = document.getElementById(`size-chart-${productId}`);

            elSizeChartOverlay.classList.add("open");
            elSizeChart.classList.remove("d-none");
        });
    });

    document.querySelectorAll('.close-size-chart-button').forEach(button => {
        button.addEventListener('click', function () {
            const productId = button.getAttribute('data-product-id');
            const elSizeChartOverlay = document.getElementById(`size-chart-overlay-${productId}`);
            const elSizeChart = document.getElementById(`size-chart-${productId}`);

            elSizeChartOverlay.classList.remove("open");
            elSizeChart.classList.add("d-none");
        });
    });

    document.querySelectorAll('.size-chart-switcher').forEach(checkbox => {
        const productId = checkbox.getAttribute('data-product-id');
        const tableCm = document.getElementById(`cm-table-${productId}`);
        const tableIN = document.getElementById(`in-table-${productId}`);

        if (checkbox && tableCm && tableIN) {
            checkbox.addEventListener('change', function () {
                if (this.checked) {
                    tableCm.classList.remove("d-none");
                    tableIN.classList.add("d-none");
                } else {
                    tableCm.classList.add("d-none");
                    tableIN.classList.remove("d-none");
                }
            });
        }
    });
});


const accordionItems = document.querySelectorAll('.accordions_inner .accordion-item');

if (accordionItems) {
    accordionItems.forEach(accordionItem => {
        accordionItem.addEventListener('click', event => {
            event.preventDefault();
            accordionItem.classList.toggle('active');
        })
    })
}
